import React from "react";
import PropTypes from "prop-types";
import { Modal } from "antd";
import Button from "./Button";
import * as styles from "../styles/components/ConfirmButton.css";

export function ActionButton({ color, label, onClick }) {
    return (
        <div className={styles.button}>
            <Button
                color={color}
                wrapperClass={styles.buttonWrapper}
                onClick={onClick}
            >
                {label}
            </Button>
        </div>
    );
}
export function ConfirmContent({
    title,
    description,
    onCancel,
    onConfirm,
    onConfirmText,
    onConfirmColor
}) {
    return (
        <div>
            <p className={styles.confirmTitle}>{title}</p>
            <p className={styles.confirmDescription}>{description}</p>
            <div className={styles.confirmButtons}>
                <ActionButton
                    label={onConfirmText}
                    color={onConfirmColor}
                    onClick={onConfirm}
                />
                <ActionButton label="Cancel" color="none" onClick={onCancel} />
            </div>
        </div>
    );
}

export default class ConfirmButton extends React.Component {
    static propTypes = {
        onConfirm: PropTypes.func.isRequired,
        onConfirmText: PropTypes.string,
        onConfirmColor: PropTypes.string,
        confirmTitle: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
        confirmDescription: PropTypes.oneOfType([
            PropTypes.object,
            PropTypes.string
        ])
    };

    static defaultProps = {
        onConfirmText: "Confirm",
        onConfirmColor: "primary"
    };

    constructor(props) {
        super(props);
        this.state = {
            confirmMenuOpen: false
        };
    }

    onClick = () => {
        this.setState({ confirmMenuOpen: true });
    };

    onCancel = () => {
        this.setState({ confirmMenuOpen: false });
    };

    onConfirm = () => {
        this.props.onConfirm();
        this.setState({ confirmMenuOpen: false });
    };

    render() {
        return (
            <div className={styles.container} onClick={this.onClick}>
                <Modal
                    onCancel={this.onCancel}
                    footer={null}
                    visible={this.state.confirmMenuOpen}
                >
                    <ConfirmContent
                        title={this.props.confirmTitle}
                        description={this.props.confirmDescription}
                        onConfirmColor={this.props.onConfirmColor}
                        onCancel={this.onCancel}
                        onConfirm={this.onConfirm}
                        onConfirmText={this.props.onConfirmText}
                    />
                </Modal>
                {this.props.children}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/ConfirmButton.js